/**
 * httpエラーをハンドリングするサービス
 */
const HandleHttpErrorService = (() => {
  /**
   * HTTPエラーをハンドリングし、トーストやモーダルで表示するメッセージを返す
   *
   * code, messageに何も入っていない場合は、[システムエラーが発生しました。管理者へお問い合わせください。]を返す
   * @param {Object} error /http/aisea/モジュールが返すエラーオブジェクト
   * @param {Number} error.code - ステータスコード
   * @param {String} error.message - エラーメッセージ
   * @returns トースト、モーダル等で表示するエラーメッセージ
   */
  const handleErrorNotificationMessage = error => {
    const defaultErrorMessage =
      "システムエラーが発生しました。管理者へお問い合わせください。";

    if (!error || !error.code || error.message === undefined) {
      return defaultErrorMessage;
    }

    switch (error.code) {
      case 400:
      case 404:
        if (error.message === "") {
          return defaultErrorMessage;
        }
        return error.message;
      case 403:
        return "権限がありません。";
      case 409:
        return "更新に失敗しました。再読み込み後に再度お試しください。";
      default:
        return defaultErrorMessage;
    }
  };

  return {
    handleErrorNotificationMessage,
  };
})();

export default HandleHttpErrorService;
